module.exports = __webpack_public_path__ + "static/media/reg1.ab370e83.jpg";